import type { Result } from 'true-myth';

import type { HttpFetcherError } from '~/shared/http-fetcher/http-fetcher';
import type { ValidatingHttpFetcherWithBaseUrl } from '~/shared/validating-http-fetcher';

import { type MyPositionsResponse, myPositionsResponseSchema } from '../../data-contract/my-positions';

export type FetchMyPositionsInput = {
    readonly acceptLanguage: string;
    readonly signal?: AbortSignal;
};

export type PersonalHomeFetchers = {
    /** The signed-in person's positions with their tasks; 403 while the "personal-home" flag is off. */
    readonly fetchMyPositions: (input: FetchMyPositionsInput) => Promise<Result<MyPositionsResponse, HttpFetcherError>>;
};

export type PersonalHomeFetchersDependencies = {
    readonly validatingCobrainerApiFetcher: ValidatingHttpFetcherWithBaseUrl;
};

const EXPECTED_STATUS_CODES = [403] as const;

export const createPersonalHomeFetchers = ({
    validatingCobrainerApiFetcher,
}: PersonalHomeFetchersDependencies): PersonalHomeFetchers => ({
    fetchMyPositions: ({ acceptLanguage, signal }) =>
        validatingCobrainerApiFetcher.get(myPositionsResponseSchema, {
            expectedStatusCodes: EXPECTED_STATUS_CODES,
            pathname: '/users/me/positions',
            requestOptions: { headers: { 'Accept-Language': acceptLanguage }, signal },
        }),
});
